import { render, staticRenderFns } from "./dialog-view-dpd.vue?vue&type=template&id=4cf57600&"
import script from "./dialog-view-dpd.vue?vue&type=script&lang=js&"
export * from "./dialog-view-dpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-view-dpd.vue"
export default component.exports